/**
 * ============================================================
 * MONTE HERMOM | LAUDO HEADER
 * ============================================================
 * ARQUIVO: /src/components/laudo/LaudoHeader.jsx
 *
 * Breadcrumb + código + status + ações
 * ============================================================
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Save, User, MoreHorizontal } from 'lucide-react';

/* ============================================================
   FORMATAÇÃO DO STATUS
   ============================================================ */
const STATUS_INFO = {
  EM_INICIACAO:                   { label: 'Em Iniciação',      cor: 'blue' },
  EM_QUALIFICACAO_REQUERENTE:     { label: 'Qualificando',      cor: 'blue' },
  FORMALIZADO:                    { label: 'Formalizado',       cor: 'blue' },
  EM_ENQUADRAMENTO:               { label: 'Enquadrando',       cor: 'blue' },
  FINALIDADE_DEFINIDA:            { label: 'Finalidade Definida', cor: 'blue' },
  AGUARDANDO_ACEITE_PROFISSIONAL: { label: 'Aguardando Aceite', cor: 'amber' },
  ACEITO_PELO_RESPONSAVEL_TECNICO:{ label: 'Aceito',            cor: 'emerald' },
  RECUSADO_PELO_PROFISSIONAL:     { label: 'Recusado',          cor: 'red' },
  EM_ELABORACAO_TECNICA:          { label: 'Em Elaboração',     cor: 'amber' },
  CRIADO:                         { label: 'Criado',            cor: 'blue' },
  EM_COMPOSICAO:                  { label: 'Em Composição',     cor: 'blue' },
  VALIDACAO_PARCIAL:              { label: 'Validação Parcial', cor: 'amber' },
  AGUARDANDO_IMOVEIS:             { label: 'Aguardando Imóveis', cor: 'amber' },
  REGIAO_EM_ANDAMENTO:            { label: 'Região em Andamento', cor: 'amber' },
  AGENDAMENTO_EM_ANDAMENTO:       { label: 'Agendando',         cor: 'amber' },
  BLOQUEADO_PARA_VISTORIA:        { label: 'Bloqueado',         cor: 'red' },
  VISTORIA_LIBERADA:              { label: 'Vistoria Liberada', cor: 'emerald' },
  EM_VISTORIA:                    { label: 'Em Vistoria',       cor: 'amber' },
  CONCLUIDO:                      { label: 'Concluído',         cor: 'emerald' },
  ENCERRADO:                      { label: 'Encerrado',         cor: 'slate' },
};

function formatarStatus(status) {
  if (!status) return { label: '—', cor: 'slate' };
  return STATUS_INFO[status] || {
    label: status.replace(/_/g, ' ').toLowerCase(),
    cor: 'slate'
  };
}

const CORES = {
  blue:    'bg-blue-500/10 text-blue-400 border-blue-500/20',
  amber:   'bg-amber-400/10 text-amber-400 border-amber-400/20',
  emerald: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  red:     'bg-red-500/10 text-red-400 border-red-500/20',
  slate:   'bg-white/5 text-slate-400 border-white/10',
};

export default function LaudoHeader({ codigo, usuario, status }) {
  const navigate = useNavigate();
  const info = formatarStatus(status);

  return (
    <header className="border-b border-white/[0.06] bg-[#0A0F1E] px-8 py-4 flex items-center justify-between">

      {/* ESQUERDA: breadcrumb + código */}
      <div className="flex items-center gap-6">

        <button
          onClick={() => navigate('/laudos')}
          className="flex items-center gap-2 text-slate-400 hover:text-white transition-all text-xs font-bold uppercase tracking-wider"
        >
          <ArrowLeft size={16} />
          Laudos
        </button>

        <div className="h-6 w-px bg-white/[0.10]" />

        <div>
          <p className="text-[9px] font-bold text-slate-500 uppercase tracking-[0.25em]">
            Laudo
          </p>
          <h1 className="text-lg font-black text-white tracking-tight">
            {codigo || 'MH-XXXX-XXXX'}
          </h1>
        </div>

        <span className={`
          px-3 py-1 rounded-full
          text-[10px] font-bold uppercase tracking-wider
          border
          ${CORES[info.cor]}
        `}>
          {info.label}
        </span>

      </div>

      {/* DIREITA: ações */}
      <div className="flex items-center gap-3">

        <button className="
          flex items-center gap-2
          px-4 py-2 rounded-xl
          text-xs font-bold uppercase tracking-wider
          text-slate-400 hover:text-white hover:bg-white/[0.05]
          transition-all
        ">
          <User size={14} />
          {usuario?.nome?.split(' ')[0] || 'Perito'}
        </button>

        <button className="
          flex items-center gap-2
          px-4 py-2 rounded-xl
          bg-amber-400 hover:bg-white
          text-slate-950
          text-xs font-bold uppercase tracking-wider
          shadow-lg shadow-amber-400/20
          transition-all
        ">
          <Save size={14} />
          Salvar
        </button>

        <button className="
          p-2 rounded-xl
          text-slate-400 hover:text-white hover:bg-white/[0.05]
          transition-all
        ">
          <MoreHorizontal size={16} />
        </button>

      </div>

    </header>
  );
}